import { AnswerDto, QuizProgressDto } from './progress.dto';

export class Answer {
    readonly questionId: string;
    readonly optionId: number;
    readonly correct: boolean | null;

    constructor(data: AnswerDto) {
        this.questionId = data.questionId ?? '';
        this.optionId = data.optionId ?? 0;
        this.correct = data.correct ?? null;
    }
}

export class QuizProgress {
    readonly quizId: string;
    readonly passed: boolean;
    readonly finished: boolean;
    readonly answers: Answer[];

    constructor(data: QuizProgressDto) {
        this.quizId = data.quizId ?? '';
        this.passed = data.passed ?? false;
        this.finished = data.finished ?? false;
        this.answers = data.answers?.map((a) => new Answer(a)) ?? [];
    }
}
